/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Enroll_Secret_LabelInputs */

const fr_totp_enroll_secret_label = /** @type {(inputs: Totp_Enroll_Secret_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou entre cette clé manuellement :`)
};

/**

* @param {Totp_Enroll_Secret_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_enroll_secret_label = /** @type {((inputs?: Totp_Enroll_Secret_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Enroll_Secret_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_enroll_secret_label(inputs)
});